import { render, staticRenderFns } from "./PupilFilter.vue?vue&type=template&id=0a632dd8&scoped=true&name=filterpupils&"
import script from "./PupilFilter.vue?vue&type=script&lang=js&"
export * from "./PupilFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a632dd8",
  null
  
)

export default component.exports